export default __webpack_public_path__ + "static/media/txt.7c05069f.svg";